"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewTeamsAppArguments = exports.PreviewTeamsAppOptions = void 0;
exports.PreviewTeamsAppOptions = [
    {
        name: "m365-host",
        type: "string",
        shortName: "m",
        description: "Preview the application in Teams, Outlook or the Microsoft 365 app.",
        required: true,
        default: "teams",
        choices: ["teams", "outlook", "office"],
    },
    {
        name: "teams-manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specifies the Microsoft Teams app manifest template file path, it can be either absolute path or relative path to project root folder, defaults to './appPackage/manifest.json'",
        required: true,
        default: "./appPackage/manifest.json",
    },
];
exports.PreviewTeamsAppArguments = [];
//# sourceMappingURL=PreviewTeamsAppOptions.js.map